import isBefore from 'date-fns/isBefore';
import isNaN from 'lodash/isNaN';
import * as Yup from 'yup';

import { formatMoney } from '../../../libs';

Yup.addMethod(Yup.string, 'minLength', function cb(values) {
  return this.test('enum', values.message, async function result(value) {
    return ((value || '').match(/\d+/g) || []).join('').length >= values.length;
  });
});

Yup.addMethod(Yup.object, 'requiredAllFields', function cb(values) {
  return this.test('object', values, async function result(value) {
    return !(!value.mes || !value.ano);
  });
});

Yup.addMethod(Yup.string, 'validateExpirationDate', function cb(values) {
  return this.test('string', values, async function result(value) {
    const [mes = null, ano = null] = value ? value.split('/') : [];

    if (!mes || !ano) {
      return false;
    }

    const date = new Date(ano, mes, '01');

    if (isNaN(date.getTime())) {
      return false;
    }

    return !isBefore(date, new Date());
  });
});

export const formatParcel = (installment) => {
  const description = installment.numeroParcelas === 1 ? 'à vista' : 'sem juros';

  return `${installment.numeroParcelas}x ${formatMoney(installment.valorParcelas)} = ${formatMoney(
    installment.valorTotal
  )} ${description}`;
};

export const yup = Yup;

export const clearMask = (value) => (value.match(/\d+/g) || []).join('');

export default { yup, formatParcel };
